import script from "./OrdersNeue.vue?vue&type=script&setup=true&lang=js"
export * from "./OrdersNeue.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import AgentSetupBanner from "@/components/ai/AgentSetupBanner.vue";
import BasicSpinner from "@/components/BasicSpinner.vue";
import BottleRow from "@/components/neue/BottleRow.vue";
import DescriptionHeader from "@/components/neue/DescriptionHeader.vue";
import EmptyState from "@/components/neue/EmptyState.vue";
import FormElement from "@/components/neue/FormElement.vue";
import FormSection from "@/components/neue/FormSection.vue";
import InputField from "@/components/neue/InputField.vue";
import NeueButton from "@/components/neue/NeueButton.vue";
import NeueLoading from "@/components/neue/NeueLoading.vue";
import NeueOrderModal from "@/components/NeueOrderModal.vue";
import NeueTablist from "@/components/neue/NeueTablist.vue";
import NeueWell from "@/components/neue/NeueWell.vue";
import NewFilterDropdown from "@/components/neue/NewFilterDropdown.vue";
import ProductionDayCalendar from "@/components/activity/ProductionDayCalendar.vue";
import SecondaryNav from "@/components/SecondaryNav.vue";
import SecondaryTop from "@/components/SecondaryTop.vue";
import SetupBanner from "@/components/setup/SetupBanner.vue";
import SetupEmptyState from "@/components/setup/SetupEmptyState.vue";
import TablistRow from "@/components/neue/TablistRow.vue";
import TheModal from "@/components/TheModal.vue";
script.components = Object.assign({}, { AgentSetupBanner, BasicSpinner, BottleRow, DescriptionHeader, EmptyState, FormElement, FormSection, InputField, NeueButton, NeueLoading, NeueOrderModal, NeueTablist, NeueWell, NewFilterDropdown, ProductionDayCalendar, SecondaryNav, SecondaryTop, SetupBanner, SetupEmptyState, TablistRow, TheModal }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { AgentSetupBanner, BasicSpinner, BottleRow, DescriptionHeader, EmptyState, FormElement, FormSection, InputField, NeueButton, NeueLoading, NeueOrderModal, NeueTablist, NeueWell, NewFilterDropdown, ProductionDayCalendar, SecondaryNav, SecondaryTop, SetupBanner, SetupEmptyState, TablistRow, TheModal }, script.__o.components);}